import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  fetchCommercialProductsV2Success,
  fetchCommercialProductsV2Fail,
  fetchCommercialProductSuccess,
  fetchCommercialProductFail
} from './actions';

import {
  FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST,
  FETCH_COMMERCIAL_PRODUCT_REQUEST
} from './actionTypes';

import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';
import { API, fetchFromApi } from '../apis';

function* commercialProductsV2() {
  const params = {};
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.commercial_product.FETCH__ALL(), params })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchCommercialProductsV2Success({ data }));
      break;
    case 'fail':
      yield put(fetchCommercialProductsV2Fail({ alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* commercialProduct({ id }) {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.product.FETCH__BY_ID(id) }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchCommercialProductSuccess({ data, id }));
      break;
    case 'fail':
      yield put(fetchCommercialProductFail({ alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* watchProducts() {
  yield all([
    yield takeLatest(FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST, commercialProductsV2),
    yield takeLatest(FETCH_COMMERCIAL_PRODUCT_REQUEST, commercialProduct)
  ]);
}

export default watchProducts;
